import React from 'react';

import CustomizedSwitch from 'components/SwitchButton/SwitchButton';

import { SettingsCard } from './SettingsCard';

interface IIntegrationEnvironmentsSectionProps {
  isProfilesEnabled: boolean;
  isToggleInProgress: boolean;
  onToggle: (enabled: boolean) => void;
}

export const IntegrationEnvironmentsSection: React.FC<
  IIntegrationEnvironmentsSectionProps
> = ({ isProfilesEnabled, isToggleInProgress, onToggle }) => {
  const handleToggle = () => {
    onToggle(!isProfilesEnabled);
  };

  return (
    <SettingsCard
      title="Integration Environments"
      description="Enable multiple integration environments (e.g., development, staging, production) for your project."
    >
      <div className="flex items-center gap-3">
        <CustomizedSwitch
          status={isProfilesEnabled}
          texts={[]}
          disabled={isToggleInProgress}
          functions={[handleToggle, handleToggle]}
        />
        <div>
          <p className="text-sm font-medium text-gray-900">
            Enable Integration Environments
          </p>
          <p className="text-[13px] text-gray-500">
            When enabled, you can configure separate API endpoints for different
            environments.
          </p>
        </div>
      </div>
    </SettingsCard>
  );
};
